import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.71,12.39a2.08,2.08,0,0,0-.34-.43L22.53,5.57,21.07,4.2l-.7-.66a2.008,2.008,0,0,0-2.74,0l-.17.16.44.41,1.03.96,5.8,5.43a3.58,3.58,0,0,1,.69.87,4.037,4.037,0,0,1,.5,1.23,4.469,4.469,0,0,1,.08.82V29h2a1.9,1.9,0,0,0,1.28-.48,1.724,1.724,0,0,0,.27-.27,1.983,1.983,0,0,0,.41-.85.615.615,0,0,0,.01-.14A1.09,1.09,0,0,0,30,27V13.42a1.84,1.84,0,0,0-.04-.41A2.24,2.24,0,0,0,29.71,12.39Z"/><path d="M23.71,12.39a2.08,2.08,0,0,0-.34-.43L15.07,4.2l-.7-.66a2.008,2.008,0,0,0-2.74,0l-9,8.42a1.876,1.876,0,0,0-.46.66,1.98,1.98,0,0,0-.17.8V27a1.752,1.752,0,0,0,.04.4,1.935,1.935,0,0,0,.55,1.01,1.813,1.813,0,0,0,.63.43A2.013,2.013,0,0,0,4,29H22a1.9,1.9,0,0,0,1.28-.48,1.724,1.724,0,0,0,.27-.27,1.983,1.983,0,0,0,.41-.85A3.582,3.582,0,0,0,24,27V13.42a1.84,1.84,0,0,0-.04-.41A2.24,2.24,0,0,0,23.71,12.39ZM17,27H9V19a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2Z"/>';
export var CommunitySVG = function CommunitySVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CommunitySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CommunitySVG);